module.exports = __webpack_public_path__ + "img/video-student.f4e4d471.png";